import { I18NConfig } from 'next/dist/server/config-shared'
import { LanguageCodeEnum } from '@systemeio/ui'
import type { I18nConfig } from 'next-i18next'
import type { UserConfig } from 'next-i18next/pages'

const supportedLngs = Object.values(LanguageCodeEnum)
const fallbackLng = LanguageCodeEnum.ENGLISH

const config: UserConfig & I18nConfig & { i18n: I18NConfig } = {
  defaultNS: 'global',
  fallbackLng,
  supportedLngs,
  localeInPath: false,
  cookieName: 'NEXT_LOCALE',
  returnEmptyString: false,
  i18nextOptions: {
    returnEmptyString: false,
  },
  i18n: {
    defaultLocale: fallbackLng,
    locales: supportedLngs,
    localeDetection: false,
  },
}

export default config
